// Bundled into vite.config.ts (i18n preload links): type-only `@/` imports only, no value imports (the config loader cannot resolve them).
// Rule for the opt-out feature flags (VITE_COMMENTS_ENABLED,
// VITE_NOTIFICATIONS_ENABLED): only an off value hides the feature. The off
// values are false, 0, off and no, in any case and with spaces trimmed. Unset,
// empty or any other value keeps the feature on.
const OFF_VALUES = ['false', '0', 'off', 'no'];

export const isOptOutFlagOn = (raw: string | undefined) =>
  !OFF_VALUES.includes(
    String(raw ?? '')
      .trim()
      .toLowerCase()
  );
